<div class="input-group" aria-label="Select GL Account">
    <input name="glAccount"
           type="text"
           placeholder="Filter GL Accounts..."
           class="form-control"
           autocomplete="off"
           container="body"
           [class.overridden]="isOverridden"
           [(ngModel)]="glAccountFilter"
           (blur)="onGlAccountBlur()"
           [wsTypeahead]="glAccounts$"
           (typeaheadNoResults)="onGlAccountNoResults($event)"
           typeaheadOptionField="displayName"
           [typeaheadOptionsLimit]="100"
           [typeaheadMinLength]="0"
           [typeaheadScrollable]="true"
           (typeaheadOnSelect)="onGlAccountSelected($event)"
           [disabled]="isLoading"/>
    @if (isLoading) {
        <span class="input-group-text visible">
            <ws-ace-loader [inline]="true"></ws-ace-loader>
        </span>
    }
</div>
